<template>
  <div class="col-lg-10" style="margin-top: 20px; margin-left: -20px;">
    <br>
    <el-form :inline="true" size="mini" :model="search" class="demo-form-inline" style="margin: 0 -15px;">
      <el-form-item label="投诉日期">
        <el-date-picker v-model="search.CreateTime_S" type="date" placeholder="开始日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker v-model="search.CreateTime_E" type="date" placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="reload">查询</el-button>
        <el-button @click="handleCreate()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table style="width: 100%"
              :data="items"
              v-loading.body="showLoading"
              element-loading-text="加载中..."
              stripe border fit highlight-current-row>
      <el-table-column label="投诉编号" min-width="15%" align="center">
        <template slot-scope="scope">
          <el-button @click="openDetail(scope.row.ID)" type="text">{{scope.row.ComplaintsNo}}</el-button>
        </template> 
      </el-table-column>
      <el-table-column prop="OrderYunDanNo" label="运单号" min-width="15%" align="center"></el-table-column>
      <el-table-column prop="TypeName" label="投诉类型" min-width="10%" align="center"></el-table-column>
      <el-table-column prop="StateName" label="投诉状态" min-width="10%" align="center"></el-table-column>
      <el-table-column prop="CreateTime" label="投诉时间" min-width="15%" align="center"></el-table-column>
      <el-table-column prop="ReplyUserName" label="处理人" min-width="10%" align="center"></el-table-column>
      <el-table-column prop="ReplyTime" label="回复时间" min-width="15%" align="center"></el-table-column>
      <el-table-column label="操作" min-width="5%" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.State==1" @click="handleScore(scope.row.ID)" type="text">评分</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="row mt10" style="margin-left: 0; margin-top: 10px;">
      <el-pagination @current-change="loadMore" background :page-size="search.PageSize" layout="total, prev, pager, next" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="新增投诉事件" width="50%" top="1vh" :visible.sync="dialogVisible">
      <div style="margin-top: 30px;">
        <el-form :rules="rules" ref="dataForm" :model="dataForm" size="mini" class="demo-form-inline" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="运单号" prop="OrderYunDanNo">
                <el-input v-model="dataForm.OrderYunDanNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉类型" prop="TypeId">
                <div class="form-group">
                  <el-select v-model="dataForm.TypeId" placeholder="--请选择--" clearable>
                    <el-option v-for="item in typeList" :key="item.key" :label="item.value" :value="item.key"></el-option>
                  </el-select>            
                </div>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉事件描述" prop="ComplaintsContent">
                <el-input type="textarea" v-model="dataForm.ComplaintsContent"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="center">
          <el-button type="primary" @click="createData">提交</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </div>
      </div>
      
    </el-dialog>

    <el-dialog title="查看详情" width="50%" top="1vh" :visible.sync="watchDialogVisible">
      <div style="margin-top: 30px;">
        <el-form ref="dataForm" :model="dataForm" size="mini" class="demo-form-inline" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉编号" prop="ComplaintsNo">
                <span>{{dataForm.ComplaintsNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运单号" prop="OrderYunDanNo">
                <span>{{dataForm.OrderYunDanNo}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉类型" prop="TypeName">
                <span>{{dataForm.TypeName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉状态" prop="StateName">
                <span>{{dataForm.StateName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉人" prop="CreateUserName">
                <span>{{dataForm.CreateUserName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回复人" prop="ReplyUserName">
                <span>{{dataForm.ReplyUserName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉时间" prop="CreateTime">
                <span>{{dataForm.CreateTime}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回复时间" prop="ReplyTime">
                <span>{{dataForm.ReplyTime}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="回复评分" prop="Score">
                <span>{{dataForm.Score}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="评分时间" prop="ScoreTime">
                <span>{{dataForm.ScoreTime}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉事件描述" prop="ComplaintsContent">
                <span>{{dataForm.ComplaintsContent}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="回复内容" prop="ReplyContent">
                <span>{{dataForm.ReplyContent}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="center">
          <el-button @click="watchDialogVisible = false">取消</el-button>
        </div>
      </div>
      
    </el-dialog>

    <el-dialog title="回复评分" width="50%" top="1vh" :visible.sync="replyDialogVisible">
      <div style="margin-top: 30px;">
        <el-form ref="dataForm" :model="dataForm" size="mini" class="demo-form-inline" label-width="120px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉编号" prop="ComplaintsNo">
                <span>{{dataForm.ComplaintsNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运单号" prop="OrderYunDanNo">
                <span>{{dataForm.OrderYunDanNo}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉类型" prop="TypeName">
                <span>{{dataForm.TypeName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉状态" prop="StateName">
                <span>{{dataForm.StateName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉人" prop="CreateUserName">
                <span>{{dataForm.CreateUserName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回复人" prop="ReplyUserName">
                <span>{{dataForm.ReplyUserName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="投诉时间" prop="CreateTime">
                <span>{{dataForm.CreateTime}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回复时间" prop="ReplyTime">
                <span>{{dataForm.ReplyTime}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉事件描述" prop="ComplaintsContent">
                <span>{{dataForm.ComplaintsContent}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="回复内容" prop="ReplyContent">
                <span>{{dataForm.ReplyContent}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="投诉建议评分" prop="Score">
                <el-input type="number" v-model="dataForm.Score"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="center">
          <el-button type="primary" @click="saveScore">提交</el-button>
          <el-button @click="replyDialogVisible = false">取消</el-button>
        </div>
      </div>
      
    </el-dialog>

  </div>
</template>

<script>
  import api from "../../api";
  import {resetTemp} from "../../libs/util";

  export default {
    components: {},
    data() {
        return {
        showLoading: false,
        dialogState: null,
        dialogVisible:false,
        items: [],
        total: 0,
        dialogFormVisible: false,
        watchDialogVisible:false,
        replyDialogVisible:false,
        typeList:[
          {key:1,value:"咨询"},
          {key:2,value:"投诉"},
          {key:3,value:"建议"},
          {key:4,value:"其他"},
        ],
        search: {
          PageNo: 1,
          PageSize: 10,
          CreateTime_S: null,
          CreateTime_E:null
        },
        dataForm: {
          ID:null,
          ComplaintsNo:null,
          OrderYunDanNo:null,
          TypeId:null,
          TypeName:null,
          State:null,
          StateName:null,
          ComplaintsContent:null,
          CreateUserID:null,
          CreateUserName:null,
          CreateTime:null,
          ReplyUserID:null,
          ReplyUserName:null,
          ReplyContent:null,
          ReplyTime:null,
          Score:null,
          ScoreTime:null,
        },
        rules: {
          ComplaintsContent:[{ required: true, message: '请输入内容' }],
          TypeId:[{ required: true, message: '请选择投诉类型' }],
        },
      };
    },
    mounted() {
      this.load()
    },
    methods: {
      load() {
        let _this = this;
        _this.showLoading = true;
        api.searchComplaints(this.search).then(res => {
          _this.showLoading = false;
          if (res.data.Succeed) {
            _this.items = res.data.Data.Data;
            _this.total = res.data.Data.totalItemCount;
          }
        });
      },
      // 新增
      handleCreate() {
        resetTemp(this.dataForm)
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      createData() {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) return
          api.addComplaints({model:this.dataForm}).then((res) => {
            if(!res.data.Succeed){
              return
            }
            this.dialogVisible = false
            this.reload()
          })
        })
      },
      openDetail(id){
        let _this = this;
        _this.showLoading = true;
        api.getComplaintsById({id:id}).then(res => {
          _this.showLoading = false;
          if (res.data.Succeed) {
            _this.dataForm = res.data.Data;
          }
        });
        this.watchDialogVisible = true
      },
      // 评分
      handleScore(id) {
        let _this = this;
        _this.showLoading = true;
        resetTemp(_this.dataForm)
        api.getComplaintsById({id:id}).then(res => {
          _this.showLoading = false;
          if (res.data.Succeed) {
            _this.dataForm = res.data.Data;
          }
        });
        this.replyDialogVisible = true
      },
      saveScore() {
        let _this = this;
        if(this.dataForm.Score==undefined){
          _this.$message({
            message: "请对投诉建议进行评分",
            type: "error"
          });
          return;
        }
        if(this.dataForm.Score>100){
          _this.$message({
            message: "评分最高为100分",
            type: "error"
          });
          return;
        }
        var scoreModel={
          ID:this.dataForm.ID,
          ComplaintsNo:this.dataForm.ComplaintsNo,
          Score:this.dataForm.Score
        }
        api.saveScore({model:scoreModel}).then((res) => {
          if(!res.data.Succeed){
            return
          }
          this.replyDialogVisible = false
          this.reload()
        })
      },
      reload() {
        this.search.PageNo = 1;
        this.load()
      },
      loadMore(n) {
        this.search.PageNo = n;
        this.load()
      },
    },
  };
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/pages/Driver/DriverComplaints.vue